<template>
	<div id="pageTitle">
		<div :style="enColor?'color:'+enColor:''" class="en">{{en}}</div>
		<h3>{{title}}</h3>
		<span>
			<i></i>
		</span>
	</div>
</template>

<script>
	export default {
		props:{
			en:String,
			enColor:String,
			title:String,
		}
	}
</script>

<style lang="scss">
	#pageTitle{
		text-align: center;
		position: relative;
		padding:0 0 12px;
		.en{
			font-size: 70px;
			font-weight: bold;
			color: #ecebeb;
			line-height:100%;
		}
		h3{
			font-size:24px;
			margin-top:-35px;
		}
		span{
			position: absolute;
			left:50%;
			bottom:0;
			height:3px;
			width:60px;
			background:#124098;
			transform: translate(-50%,0);
			i{
				display: block;
				background:#FFF;
				height:100%;
				width:3px;
				float:right;
				margin-right:13px;
			}
		}
	}
	@media screen and(max-width:768px) {
		#pageTitle{
			padding:0 0 12px;
			.en{
				font-size: 32px;
				font-weight: bold;
				color: #ecebeb;
				line-height:100%;
			}
			h3{
				font-size:16px;
				margin-top:-15px;
				color:#124098;
			}
			span{
				position: absolute;
				left:50%;
				bottom:0;
				height:3px;
				width:60px;
				background:#124098;
				transform: translate(-50%,0);
				i{
					display: block;
					background:#FFF;
					height:100%;
					width:3px;
					float:right;
					margin-right:13px;
				}
			}
		}
	}
</style>
